import type { DriverScheduleMode, ScheduleEntry } from '@/services/drivers/driverService';

export interface DriverScheduleDraft {
  mode: DriverScheduleMode;
  schedule?: ScheduleEntry[];
}

export type VehicleAssignmentDraft =
  | {
      kind: 'pick';
      vehicleId: number;
      startDate: string;
      startTripId?: string;
    }
  | {
      kind: 'link';
      vehicleId: number;
      deviceImei: string;
      startDate: string;
      handleExistingDevice: 'UNMOUNT' | 'SWAP';
    }
  | {
      kind: 'register';
      startDate: string;
      deviceImei?: string | null;
      vehicle: {
        registration_number: string;
        vin?: string;
        make?: string;
        model?: string;
        year?: number;
        fuel_type?: string;
        initial_odometer?: number;
      };
    };

export interface DriverSetupDraft {
  schedule: DriverScheduleDraft | null;
  vehicleAssignment: VehicleAssignmentDraft | null;
}

export const emptyDriverSetupDraft = (): DriverSetupDraft => ({
  schedule: null,
  vehicleAssignment: null,
});
